_onload_functions[_onload_functions.length] = function() {

  $(".show_hide").on("click", function() {
    return false;
  });
	jQuery(".show_hide").each(function() {
   var el = $(this);
   el.qtip({
     "style": 'searchpopup',
     "content": jQuery(".search_panel"), // Set the tooltip content to the current corner
     "position": {
       "my": 'top left',
       "at": 'bottom left',
       "adjust": {
         "y": 30
       }
     },
      "show": {
				"event": "click",
        "solo": true
      },
      "hide": {
       "event": 'unfocus'
      }
    });
 }).click(function(){return false});;


  $("#search_form_reset").on("click", function() {
    $("#search_form_data :checkbox").removeAttr("checked");
  });

};
